var _g, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 276,
    viewBox: "0 0 298 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_911)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_42_911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.831 137.403C173.831 137.403 172.093 179.413 168.473 187.124C164.853 194.835 143.426 230.337 134.983 229.514C119.005 227.931 96.1285 153.064 93.3318 143.714C91.9634 141.48 90.5175 140.037 88.157 138.943C76.7416 133.6 74.7434 129.22 72.3548 125.319L70.6381 113.805C75.8515 110.748 80.0765 119.296 81.4801 121.322C85.2091 126.705 89.9511 125.41 91.6432 125.192C94.1339 124.861 90.3944 121.875 88.9626 119.169C86.8976 115.268 89.5782 113.02 89.5782 113.02C90.0919 115.075 98.7247 124.45 101.479 127.672C104.012 130.631 103.773 136.794 103.717 137.789C107.164 143.038 133.777 188.623 133.777 188.623C133.777 188.623 148.784 152.628 154.884 145.937C159.316 141.096 169.606 138.774 173.831 137.403Z",
    fill: "#FFD1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9412 125.413C77.9412 125.413 77.2059 121.34 74.849 119.145C74.849 119.145 74.0821 114.624 71.0286 113.868",
    stroke: "#EEB9AF",
    strokeWidth: 1.05536,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2947 124.464C80.2947 124.464 79.3625 120.446 76.9 118.353C76.9 118.353 74.3671 112.144 71.0638 113.851",
    stroke: "#EEB9AF",
    strokeWidth: 1.05536,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9931 332.679C78.9931 332.679 73.4173 300.899 95.2316 286.845C117.046 272.791 180.747 261.221 177.975 246.928L233.776 245.668C233.776 245.668 246.394 264.063 248.438 283.577C250.809 306.165 245.701 323.237 199.54 323.142C174.767 323.089 178.186 338.427 178.186 338.427C178.186 338.427 153.818 344.872 124.402 343.82C94.9853 342.768 78.9931 332.679 78.9931 332.679Z",
    fill: "#424D76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.617 133.251C181.296 134.004 173.831 137.399 173.831 137.399C173.831 137.399 163.63 176.095 161.167 181.298C158.704 186.501 157.097 194.873 167.499 202.342L178.053 247.599H233.793C233.793 247.599 238.092 200.305 241.037 183.785C243.981 167.265 240.301 135.664 240.301 135.664L219.659 133.251H184.617Z",
    fill: "#FFB000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.711 236.135C278.248 250.878 193.605 247.912 188.135 247.705C186.826 249.059 182.214 253.446 178.285 252.588C173.648 251.568 169.722 248.803 166.869 250.146C164.016 251.49 160.745 254.29 158.824 254.157C156.539 254.021 154.29 253.522 152.161 252.679C153.515 250.737 154.973 248.869 156.53 247.086C154.849 247.839 152.573 249.439 151.338 250.03C150.813 250.307 150.211 250.401 149.627 250.296C149.043 250.19 148.511 249.893 148.116 249.45C148.116 249.45 152.337 245.654 153.871 244.739C155.324 243.86 159.851 241.707 162.053 241.549C164.713 241.162 180.501 238.031 187.769 238.773V238.836C190.956 237.982 249.296 222.38 253.405 221.497C253.405 221.497 238.922 173.978 236.963 166.136C235.003 158.295 234.342 135.098 240.301 135.661C244.171 136.03 252.966 136.864 258.091 148.645C261.743 157.021 283.771 217.937 280.711 236.135Z",
    fill: "#FFD1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.578 252.831C154.578 252.831 160.91 246.214 162.56 245.795C165.483 245.07 169.3 244.11 169.3 244.11",
    stroke: "#EEB9AF",
    strokeWidth: 1.05536,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.607 253.235C157.607 253.235 163.074 248.074 164.734 247.663C167.657 246.938 171.474 245.981 171.474 245.981",
    stroke: "#EEB9AF",
    strokeWidth: 1.05536,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.706 110.322C191.706 111.979 195.174 122.842 184.617 133.251C184.617 133.251 199.248 138.683 219.645 133.251C219.645 133.251 213.759 110.522 213.9 103.747L191.706 110.322Z",
    fill: "#FFD1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.786 108.802C210.73 119.707 199.255 128.351 188.35 128.762C194.253 119.911 191.706 111.743 191.706 110.322L211.427 104.412C211.627 106.121 211.881 107.831 211.786 108.802Z",
    fill: "#F3C2B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.098 89.3842C177.838 87.9067 177.064 78.3592 182.281 73.8458C192.195 65.2622 210.512 61.6212 221.491 67.7739C232.08 73.6945 236.298 81.5288 234.596 96.6908C232.97 111.195 229.463 114.129 238.465 124.855C246.556 134.497 249.065 148.104 244.154 159.52C232.175 187.364 255.411 186.773 255.411 200.834H219.409C219.409 200.834 194.267 179.062 206.551 151.992C217.544 127.775 219.458 119.472 211.592 106.259C207.459 99.301 179.098 89.3842 179.098 89.3842Z",
    fill: "#424D76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.603 66.8807C227.866 69.8955 239.654 80.6391 237.951 95.7976C236.326 110.302 232.819 113.25 241.821 123.962C249.912 133.604 252.42 147.215 247.51 158.627C235.549 186.474 258.767 185.883 258.767 199.94",
    stroke: "#424D76",
    strokeWidth: 1.05536,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.508 99.1533C211.508 99.1533 217.136 98.4286 217.506 100.472C218.244 104.627 212.035 106.249 212.035 106.249C212.035 106.249 210.91 109.278 209.52 112.321C208.7 114.118 196.268 120.021 190.643 119.43C185.018 118.839 179.622 104.208 179.555 91.1642C179.499 81.6906 182.587 76.741 189.099 76.741C198.175 76.741 202.417 83.4671 208.634 81.5464C208.623 81.5429 204.553 91.0129 211.508 99.1533Z",
    fill: "#FFD1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.902 103.35C184.557 103.35 187.519 100.387 187.519 96.7327C187.519 93.0781 184.557 90.1156 180.902 90.1156C177.248 90.1156 174.285 93.0781 174.285 96.7327C174.285 100.387 177.248 103.35 180.902 103.35Z",
    stroke: "#FFB000",
    strokeWidth: 1.40715,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.405 103.35C201.059 103.35 204.022 100.387 204.022 96.7327C204.022 93.0781 201.059 90.1156 197.405 90.1156C193.75 90.1156 190.788 93.0781 190.788 96.7327C190.788 100.387 193.75 103.35 197.405 103.35Z",
    stroke: "#FFB000",
    strokeWidth: 1.40715,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.516 96.7326H190.788",
    stroke: "#FFB000",
    strokeWidth: 1.40715,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.022 96.7326H217.858",
    stroke: "#FFB000",
    strokeWidth: 1.40715,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_42_911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.036 76.9298L12.772 98.2359C10.4787 98.6561 8.96037 100.856 9.38062 103.149L14.1364 129.101C14.5567 131.394 16.7564 132.913 19.0497 132.492L135.314 111.186C137.607 110.766 139.125 108.566 138.705 106.273L133.949 80.3212C133.529 78.0279 131.329 76.5096 129.036 76.9298Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20.2079,
    cy: 107.27,
    r: 1.98939,
    transform: "rotate(-10.4623 20.2079 107.27)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.3902,
    cy: 113.673,
    r: 1.98939,
    transform: "rotate(-10.4623 21.3902 113.673)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5724,
    cy: 120.075,
    r: 1.98939,
    transform: "rotate(-10.4623 22.5724 120.075)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.2548,
    cy: 106.154,
    r: 1.98939,
    transform: "rotate(-10.4623 26.2548 106.154)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.437,
    cy: 112.556,
    r: 1.98939,
    transform: "rotate(-10.4623 27.437 112.556)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.6193,
    cy: 118.959,
    r: 1.98939,
    transform: "rotate(-10.4623 28.6193 118.959)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6308,
    y: 107.762,
    width: 44,
    height: 6,
    transform: "rotate(-10.4623 39.6308 107.762)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_42_911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.861 63.952L3.77857 58.6782C1.44946 58.5742 -0.522987 60.378 -0.62701 62.7071L-1.8042 89.0648C-1.90822 91.3939 -0.104427 93.3663 2.22469 93.4704L120.307 98.7442C122.636 98.8482 124.609 97.0444 124.713 94.7153L125.89 68.3576C125.994 66.0285 124.19 64.056 121.861 63.952Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 9.00226,
    cy: 69.1486,
    r: 1.98939,
    transform: "rotate(2.47954 9.00226 69.1486)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.72058,
    cy: 75.6533,
    r: 1.98939,
    transform: "rotate(2.47954 8.72058 75.6533)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.43892,
    cy: 82.1576,
    r: 1.98939,
    transform: "rotate(2.47954 8.43892 82.1576)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.1456,
    cy: 69.4146,
    r: 1.98939,
    transform: "rotate(2.47954 15.1456 69.4146)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.8639,
    cy: 75.9193,
    r: 1.98939,
    transform: "rotate(2.47954 14.8639 75.9193)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5822,
    cy: 82.4237,
    r: 1.98939,
    transform: "rotate(2.47954 14.5822 82.4237)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.8216,
    y: 73.9779,
    width: 44,
    height: 6,
    transform: "rotate(2.47954 27.8216 73.9779)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_42_911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.906 15.744L10.8023 31.8066C8.4925 32.1234 6.87686 34.2527 7.19369 36.5625L10.7791 62.7018C11.0959 65.0116 13.2252 66.6272 15.535 66.3104L132.639 50.2478C134.949 49.9309 136.564 47.8016 136.247 45.4918L132.662 19.3526C132.345 17.0428 130.216 15.4272 127.906 15.744Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 17.825,
    cy: 41.166,
    r: 1.98939,
    transform: "rotate(-7.88797 17.825 41.166)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.7185,
    cy: 47.6152,
    r: 1.98939,
    transform: "rotate(-7.88797 18.7185 47.6152)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.612,
    cy: 54.064,
    r: 1.98939,
    transform: "rotate(-7.88797 19.612 54.064)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.9159,
    cy: 40.3221,
    r: 1.98939,
    transform: "rotate(-7.88797 23.9159 40.3221)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.8094,
    cy: 46.7713,
    r: 1.98939,
    transform: "rotate(-7.88797 24.8094 46.7713)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.7029,
    cy: 53.2201,
    r: 1.98939,
    transform: "rotate(-7.88797 25.7029 53.2201)",
    fill: "#B1B8D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.2061,
    y: 42.5297,
    width: 44,
    height: 6,
    transform: "rotate(-7.88797 37.2061 42.5297)",
    fill: "#B1B8D4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.69 36.7992C165.69 38.8079 165.144 40.3449 164.051 41.4103C162.963 42.4701 161.395 43 159.348 43H155.977V30.8315H159.706C161.598 30.8315 163.068 31.3558 164.117 32.4046C165.166 33.4533 165.69 34.9182 165.69 36.7992ZM164.192 36.8491C164.192 35.2622 163.792 34.0664 162.993 33.2618C162.2 32.4573 161.018 32.055 159.448 32.055H157.392V41.7765H159.115C160.802 41.7765 162.07 41.3631 162.919 40.5363C163.768 39.704 164.192 38.4749 164.192 36.8491ZM172.365 33.7113C172.77 33.7113 173.134 33.7446 173.456 33.8112L173.264 35.0929C172.887 35.0097 172.554 34.9681 172.266 34.9681C171.528 34.9681 170.895 35.2677 170.368 35.867C169.846 36.4663 169.585 37.2126 169.585 38.106V43H168.204V33.8778H169.344L169.502 35.5674H169.569C169.907 34.9736 170.315 34.5159 170.792 34.194C171.27 33.8722 171.794 33.7113 172.365 33.7113ZM180.772 43L180.497 41.7016H180.431C179.976 42.2731 179.521 42.6615 179.066 42.8668C178.616 43.0666 178.053 43.1665 177.376 43.1665C176.472 43.1665 175.761 42.9334 175.245 42.4673C174.735 42.0012 174.479 41.3381 174.479 40.4781C174.479 38.6359 175.953 37.6704 178.899 37.5816L180.447 37.5317V36.9657C180.447 36.2499 180.292 35.7227 179.981 35.3843C179.676 35.0402 179.185 34.8682 178.508 34.8682C177.748 34.8682 176.888 35.1013 175.928 35.5674L175.503 34.5103C175.953 34.2662 176.444 34.0747 176.976 33.936C177.515 33.7973 178.053 33.7279 178.591 33.7279C179.679 33.7279 180.483 33.9693 181.005 34.4521C181.532 34.9348 181.796 35.7089 181.796 36.7742V43H180.772ZM177.651 42.0262C178.511 42.0262 179.185 41.7904 179.673 41.3187C180.167 40.8471 180.414 40.1868 180.414 39.3378V38.5138L179.032 38.5721C177.934 38.6109 177.14 38.7829 176.652 39.0881C176.169 39.3877 175.928 39.8566 175.928 40.4947C175.928 40.9941 176.078 41.3742 176.377 41.635C176.682 41.8958 177.107 42.0262 177.651 42.0262ZM192.116 33.8778V34.7517L190.427 34.9515C190.582 35.1457 190.721 35.4009 190.843 35.7172C190.965 36.0279 191.026 36.3803 191.026 36.7742C191.026 37.6676 190.721 38.3806 190.11 38.9133C189.5 39.446 188.662 39.7123 187.597 39.7123C187.325 39.7123 187.07 39.6901 186.831 39.6457C186.243 39.9565 185.949 40.3477 185.949 40.8193C185.949 41.069 186.052 41.2549 186.257 41.377C186.462 41.4935 186.814 41.5518 187.314 41.5518H188.929C189.916 41.5518 190.674 41.7598 191.201 42.176C191.734 42.5922 192 43.197 192 43.9905C192 45.0003 191.595 45.7689 190.785 46.296C189.975 46.8287 188.793 47.095 187.239 47.095C186.046 47.095 185.125 46.8731 184.476 46.4292C183.832 45.9853 183.51 45.3582 183.51 44.5481C183.51 43.9932 183.688 43.5133 184.043 43.1082C184.398 42.7031 184.897 42.4285 185.541 42.2842C185.308 42.1788 185.111 42.0151 184.95 41.7931C184.795 41.5712 184.717 41.3132 184.717 41.0191C184.717 40.6861 184.806 40.3948 184.983 40.1451C185.161 39.8954 185.441 39.6541 185.824 39.421C185.352 39.2268 184.967 38.8967 184.667 38.4306C184.373 37.9645 184.226 37.4318 184.226 36.8325C184.226 35.8337 184.526 35.0652 185.125 34.527C185.724 33.9832 186.573 33.7113 187.672 33.7113C188.149 33.7113 188.579 33.7668 188.962 33.8778H192.116ZM184.842 44.5315C184.842 45.0253 185.05 45.3999 185.466 45.6551C185.882 45.9103 186.479 46.038 187.256 46.038C188.415 46.038 189.273 45.8632 189.827 45.5136C190.388 45.1696 190.668 44.7007 190.668 44.107C190.668 43.6131 190.516 43.2691 190.21 43.0749C189.905 42.8862 189.331 42.7919 188.487 42.7919H186.831C186.204 42.7919 185.716 42.9417 185.366 43.2414C185.017 43.541 184.842 43.971 184.842 44.5315ZM185.591 36.7992C185.591 37.4373 185.771 37.9201 186.132 38.2474C186.493 38.5748 186.995 38.7385 187.638 38.7385C188.987 38.7385 189.661 38.0838 189.661 36.7742C189.661 35.4037 188.979 34.7184 187.614 34.7184C186.964 34.7184 186.465 34.8932 186.115 35.2428C185.766 35.5923 185.591 36.1112 185.591 36.7992ZM201.363 42.0262C201.608 42.0262 201.843 42.0095 202.071 41.9762C202.298 41.9374 202.479 41.8986 202.612 41.8597V42.9168C202.462 42.9889 202.24 43.0472 201.946 43.0916C201.658 43.1415 201.397 43.1665 201.164 43.1665C199.399 43.1665 198.517 42.237 198.517 40.3782V34.9515H197.21V34.2856L198.517 33.7113L199.1 31.7637H199.899V33.8778H202.545V34.9515H199.899V40.3199C199.899 40.8693 200.029 41.291 200.29 41.5851C200.551 41.8791 200.908 42.0262 201.363 42.0262ZM212.317 38.4306C212.317 39.9176 211.942 41.0801 211.193 41.918C210.444 42.7503 209.409 43.1665 208.089 43.1665C207.273 43.1665 206.549 42.975 205.916 42.5922C205.284 42.2093 204.795 41.66 204.451 40.9442C204.107 40.2284 203.935 39.3905 203.935 38.4306C203.935 36.9435 204.307 35.7866 205.051 34.9598C205.794 34.1275 206.826 33.7113 208.147 33.7113C209.423 33.7113 210.436 34.1358 211.185 34.9847C211.939 35.8337 212.317 36.9823 212.317 38.4306ZM205.367 38.4306C205.367 39.5958 205.6 40.4836 206.066 41.094C206.532 41.7044 207.217 42.0095 208.122 42.0095C209.026 42.0095 209.712 41.7071 210.178 41.1023C210.649 40.4919 210.885 39.6014 210.885 38.4306C210.885 37.2709 210.649 36.3914 210.178 35.7921C209.712 35.1873 209.021 34.8849 208.105 34.8849C207.201 34.8849 206.518 35.1817 206.058 35.7755C205.597 36.3692 205.367 37.2542 205.367 38.4306ZM223.337 33.7113C223.742 33.7113 224.105 33.7446 224.427 33.8112L224.236 35.0929C223.858 35.0097 223.525 34.9681 223.237 34.9681C222.499 34.9681 221.866 35.2677 221.339 35.867C220.818 36.4663 220.557 37.2126 220.557 38.106V43H219.175V33.8778H220.315L220.474 35.5674H220.54C220.879 34.9736 221.286 34.5159 221.764 34.194C222.241 33.8722 222.765 33.7113 223.337 33.7113ZM229.987 43.1665C228.639 43.1665 227.573 42.7559 226.791 41.9346C226.014 41.1134 225.626 39.9731 225.626 38.5138C225.626 37.0434 225.986 35.8753 226.708 35.0097C227.435 34.1441 228.408 33.7113 229.629 33.7113C230.772 33.7113 231.677 34.0886 232.342 34.8433C233.008 35.5923 233.341 36.5828 233.341 37.8146V38.6886H227.057C227.085 39.7595 227.354 40.5724 227.865 41.1273C228.381 41.6822 229.105 41.9596 230.037 41.9596C231.019 41.9596 231.99 41.7543 232.95 41.3437V42.5755C232.462 42.7864 231.998 42.9362 231.56 43.025C231.127 43.1193 230.603 43.1665 229.987 43.1665ZM229.612 34.8682C228.88 34.8682 228.295 35.1068 227.856 35.584C227.423 36.0612 227.168 36.7215 227.091 37.5649H231.86C231.86 36.6938 231.666 36.0279 231.277 35.5674C230.889 35.1013 230.334 34.8682 229.612 34.8682ZM234.939 39.0631V37.798H239.026V39.0631H234.939ZM249.072 38.4306C249.072 39.9176 248.698 41.0801 247.948 41.918C247.199 42.7503 246.165 43.1665 244.844 43.1665C244.028 43.1665 243.304 42.975 242.672 42.5922C242.039 42.2093 241.551 41.66 241.207 40.9442C240.863 40.2284 240.691 39.3905 240.691 38.4306C240.691 36.9435 241.062 35.7866 241.806 34.9598C242.549 34.1275 243.582 33.7113 244.902 33.7113C246.178 33.7113 247.191 34.1358 247.94 34.9847C248.695 35.8337 249.072 36.9823 249.072 38.4306ZM242.122 38.4306C242.122 39.5958 242.355 40.4836 242.821 41.094C243.287 41.7044 243.973 42.0095 244.877 42.0095C245.782 42.0095 246.467 41.7071 246.933 41.1023C247.405 40.4919 247.641 39.6014 247.641 38.4306C247.641 37.2709 247.405 36.3914 246.933 35.7921C246.467 35.1873 245.776 34.8849 244.861 34.8849C243.956 34.8849 243.274 35.1817 242.813 35.7755C242.353 36.3692 242.122 37.2542 242.122 38.4306ZM255.664 33.7113C256.069 33.7113 256.433 33.7446 256.754 33.8112L256.563 35.0929C256.186 35.0097 255.853 34.9681 255.564 34.9681C254.826 34.9681 254.194 35.2677 253.667 35.867C253.145 36.4663 252.884 37.2126 252.884 38.106V43H251.502V33.8778H252.643L252.801 35.5674H252.867C253.206 34.9736 253.614 34.5159 254.091 34.194C254.568 33.8722 255.093 33.7113 255.664 33.7113ZM264.67 41.7765H264.595C263.957 42.7031 263.002 43.1665 261.732 43.1665C260.539 43.1665 259.609 42.7586 258.943 41.943C258.283 41.1273 257.953 39.9676 257.953 38.4638C257.953 36.9601 258.286 35.7921 258.952 34.9598C259.618 34.1275 260.544 33.7113 261.732 33.7113C262.969 33.7113 263.918 34.1607 264.578 35.0597H264.686L264.628 34.4021L264.595 33.7612V30.0491H265.977V43H264.853L264.67 41.7765ZM261.907 42.0095C262.85 42.0095 263.532 41.7543 263.954 41.2438C264.381 40.7278 264.595 39.8982 264.595 38.7552V38.4638C264.595 37.171 264.378 36.2499 263.946 35.7005C263.518 35.1457 262.833 34.8682 261.89 34.8682C261.08 34.8682 260.458 35.1845 260.025 35.8171C259.598 36.4441 259.385 37.3319 259.385 38.4805C259.385 39.6457 259.598 40.5252 260.025 41.119C260.453 41.7127 261.08 42.0095 261.907 42.0095ZM272.768 43.1665C271.42 43.1665 270.355 42.7559 269.572 41.9346C268.795 41.1134 268.407 39.9731 268.407 38.5138C268.407 37.0434 268.768 35.8753 269.489 35.0097C270.216 34.1441 271.19 33.7113 272.41 33.7113C273.553 33.7113 274.458 34.0886 275.124 34.8433C275.79 35.5923 276.123 36.5828 276.123 37.8146V38.6886H269.839C269.866 39.7595 270.135 40.5724 270.646 41.1273C271.162 41.6822 271.886 41.9596 272.818 41.9596C273.8 41.9596 274.771 41.7543 275.731 41.3437V42.5755C275.243 42.7864 274.78 42.9362 274.341 43.025C273.909 43.1193 273.384 43.1665 272.768 43.1665ZM272.394 34.8682C271.661 34.8682 271.076 35.1068 270.638 35.584C270.205 36.0612 269.95 36.7215 269.872 37.5649H274.641C274.641 36.6938 274.447 36.0279 274.058 35.5674C273.67 35.1013 273.115 34.8682 272.394 34.8682ZM282.648 33.7113C283.053 33.7113 283.416 33.7446 283.738 33.8112L283.547 35.0929C283.17 35.0097 282.837 34.9681 282.548 34.9681C281.81 34.9681 281.178 35.2677 280.65 35.867C280.129 36.4663 279.868 37.2126 279.868 38.106V43H278.486V33.8778H279.627L279.785 35.5674H279.851C280.19 34.9736 280.598 34.5159 281.075 34.194C281.552 33.8722 282.076 33.7113 282.648 33.7113Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_42_911",
    x: -8.68927,
    y: 70.8599,
    width: 165.464,
    height: 91.7022,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_42_911"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.900301 0 0 0 0 0.900301 0 0 0 0 0.925183 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_911"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42_911",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_42_911",
    x: -19.8085,
    y: 52.6739,
    width: 163.703,
    height: 76.0745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_42_911"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.900301 0 0 0 0 0.900301 0 0 0 0 0.925183 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_911"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42_911",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_42_911",
    x: -10.846,
    y: 9.70432,
    width: 165.133,
    height: 86.6457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_42_911"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.900301 0 0 0 0 0.900301 0 0 0 0 0.925183 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_911"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_42_911",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 298,
    height: 276,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_42_911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 281,
    height: 487.9,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReOrder);
export default __webpack_public_path__ + "static/media/re-order.1051efdc.svg";
export { ForwardRef as ReactComponent };